module.exports = __webpack_public_path__ + "static/media/about.8a7e3bee.png";